export const CONFIG = {
  "PROJECTNAME": "ag",
  "COMPANYNAME": "AG",
  "DFTLNGCODE": "de",
  "URL": "https://api.fbsshop.de",
  "PAYMENTSERVER": "https://stripe.mobiapi.de",
  "VENDORID": "10087004",
  "IMAGEURL": "/images",
  "PAYMENTSYSTEM": true,
  "BANNER": false,
  "BRANDS": false,
  "FLAG_ITEM_ON_HAND": false,
  "MENU_LOGO_BACKGROUND": false,
  "LOGO_LOGIN_BACKGROUND": false,
  "MENU_WHITE_BACKGROUND": false,
  "colors": {
    "primary": "#9c742e",
    "primary100": "#e7f1f0",
    "light": "#9c742e",
    "secondary": "#9c742e",
    "dark": "#9c742e",
    "siteColor3": "#fff",
    "menuSecondary": "#9c742e"
  }
};